import { render, staticRenderFns } from "./invoice-actions-menu.vue?vue&type=template&id=1c28ef87&scoped=true"
import script from "./invoice-actions-menu.vue?vue&type=script&lang=js"
export * from "./invoice-actions-menu.vue?vue&type=script&lang=js"
import style0 from "./invoice-actions-menu.vue?vue&type=style&index=0&id=1c28ef87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c28ef87",
  null
  
)

export default component.exports